/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CommonService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Calculate Relative Date
     * @param standingIn
     * @param reldateString
     * @param fiscalYearEndMonth
     * @returns string Successful Response
     * @throws ApiError
     */
    public calculateRelativeDate(
        standingIn: string,
        reldateString: string,
        fiscalYearEndMonth?: (number | null),
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/common/calculate-relative-date',
            query: {
                'standing_in': standingIn,
                'reldate_string': reldateString,
                'fiscal_year_end_month': fiscalYearEndMonth,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Holiday List
     * Get list of holidays for current year for a given country code.
     * Returns a list of holiday details sorted by date.
     * @param countryCode
     * @returns string Successful Response
     * @throws ApiError
     */
    public getHolidayList(
        countryCode: string,
    ): CancelablePromise<Array<Record<string, string>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/common/get-holiday-list',
            query: {
                'country_code': countryCode,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
